var exports = {
  "k": "x61f99309--5f3f1e--container",
};

module.exports = exports;
